import snake_case from 'lodash.snakecase';
import { LogEvent, LogEventKey } from "src/app/interfaces/log";
import { LogService } from '../log.service';
import { AskNewPostContentInputDismissedParams, AskNewPostContentInputViewedParams, AskNewPostMbtiPickerOpenedParams, AskNewPostMbtiSelectDismissedParams, AskNewPostMbtiSelectViewedParams, AskNewPostMbtiSelectedParams, AskNewPostPostSubmitClickedParams, AskPostDetailCommentDeleteClickedParams, AskPostDetailCommentDeleteDialogViewedParams, AskPostDetailCommentLikeClickedParams, AskPostDetailCommentReportClickedParams, AskPostDetailCommentReportDialogViewedParams, AskPostDetailCommentSubmitClickedParams, AskPostDetailNavigationBackPerformedParams, AskPostDetailNewPostClickedParams, AskPostDetailPostDeleteClickedParams, AskPostDetailPostDeleteDialogViewedParams, AskPostDetailPostLikeClickedParams, AskPostDetailPostReportClickedParams, AskPostDetailPostReportDialogViewedParams, AskPostDetailScrollEndedParams, AskPostDetailViewedParams, HomeAskImpressionParams, HomeAskMorePostClickedParams, HomeAskNewPostClickedParams, HomeAskPostItemClickedParams } from "./ask-log";

export class AskLogService {
  constructor(
    private logService: LogService
  ) {
  }
  /**
   * 로깅 붙임 여부(O)
   * [홈 탭] 노출된 애스크 목록 UI 목격함
   * [Event Name]
   *  - Amplitude: Home - Ask Impression
   *  - GA: impression
   * [Event Parameters]
   *  - screen_name: 화면 식별자 (home)
   *  - header_title: 목록 UI 상단 제목 텍스트 (e.g. 성격 유형에게 물어보세요)
   *  - user_mbti: 접속자의 MBTI (e.g. ENFP)
   *  - post_count: 전체 영역에 걸쳐 노출된 포스트 개수 (e.g. 5)
   */
  homeAskImpression(params: HomeAskImpressionParams): void {
    this.eventLogging(LogEvent.HOME_ASK_IMPRESSION, params);
  }
  
  /**
   * 로깅 붙임 여부(O)
   * [홈 탭] 애스크 목록 UI 내에 ‘질문하기’를 누름
   * [Event Name]
   *  - Amplitude: Home - Ask New Post Clicked
   *  - GA: click_ask_new_post
   * [Event Parameters]
   *  • screen_name: 화면 식별자 (home)
   *  • header_title: 목록 UI 상단 제목 텍스트 (e.g. 성격 유형에게 물어보세요)
   *  • user_mbti: 접속자의 MBTI (e.g. ENFP)
   *  • post_count: 전체 영역에 걸쳐 노출된 포스트 개수 (e.g. 5)
   */
  homeAskNewPostClicked(params: HomeAskNewPostClickedParams): void {
    this.eventLogging(LogEvent.HOME_ASK_NEW_POST_CLICKED, params);
  }
  
  
  /**
   * 로깅 붙임 여부(O)
   * [홈 탭] 애스크 목록 중 항목을 누름 (애스크 상세 화면으로 전환)
   * [Event Name]
   *  - Amplitude: Home - Ask Post Item Clicked
   *  - GA: click_ask_post_detail
   * [Event Parameters]
   *  • screen_name: 화면 식별자 (home)
   *  • header_title: 목록 UI 상단 제목 텍스트 (e.g. 성격 유형에게 물어보세요)
   *  • section_title: 분할 영역의 상위 타이틀 (e.g. ENFP에게 도착한 질문)
   *  • user_mbti: 접속자의 MBTI (e.g. ENFP)
   *  • post_count: 분할 영역에 노출된 포스트 개수 (e.g. 2)
   *  • summary: 항목의 텍스트(잘렸으면 전부가 아니라 끝에 화면에 표시된 것처럼 생략부호까지 로깅) (e.g. ENFP여러분 시험공부 잘 되시나요 ㅜ…)
   *  • comment_count: 항목의 댓글 수 (e.g. 12)
   *  • target_mbti: 항목의 질문 대상이 되는 MBTI. 필터가 없으면 공란. (e.g. INTP)
   *  • is_target_mbti_mine: 접속자의 MBTI와 항목의 질문 대상이 되는 MBTI가 같은지 여부 (true | false)
   *  • created_at: 항목의 등록 일시(UTC 기준) (e.g. 2022-01-11 15:33:20) 
   */
  homeAskPostItemClicked(params: HomeAskPostItemClickedParams): void {
    this.eventLogging(LogEvent.HOME_ASK_POST_ITEM_CLICKED, params);
  }
  
  
  /**
   * 로깅 붙임 여부(O)
   * [홈 탭] 애스크 목록 UI 내에 ‘더보기’를 누름
   * [Event Name]
   *  - Amplitude: Home - Ask More Post Clicked
   *  - GA: click_more
   * [Event Parameters]
   *  • screen_name: 화면 식별자 (home)
   *  • header_title: 목록 UI 상단 제목 텍스트 (e.g. 성격 유형에게 물어보세요)
   *  • section_title: 분할 영역의 상위 타이틀 (e.g. ENFP에게 도착한 질문)
   *  • user_mbti: 접속자의 MBTI (e.g. ENFP)
   *  • post_count: 분할 영역에 노출된 포스트 개수 (e.g. 2)
   */
  homeAskMorePostClicked(params: HomeAskMorePostClickedParams): void {
    this.eventLogging(LogEvent.HOME_ASK_MORE_POST_CLICKED, params);
  }
  
  
  /**
   * 로깅 붙임 여부(O)
   * [애스크 상세 화면] 화면 진입함
   * [Event Name]
   *  - Amplitude: Ask Post Detail - Viewed
   *  - GA: visit_ask_detail
   * [Event Parameters]
   *  • screen_name: 화면 식별자 (ask_post_detail)
   *  • post_id: 진입점이 된 질문의 고유 식별자 (e.g. 123)
   *  • created_at: 진입점이 된 질문 등록 일시(UTC 기준) (e.g. 2022-01-11 15:33:20) 
   *  • like_count: 진입점이 된 질문의 라이크 개수 (e.g. 6)
   *  • comment_count: 진입점이 된 질문의 댓글 개수 (e.g. 8)
   *  • user_mbti: 접속자의 MBTI (e.g. ENFP)
   *  • list_mbti: 현재 상세 화면의 질문 대상이 되는 MBTI. 필터가 없으면 공란. (e.g. INTP)
   *  • is_list_mbti_mine: 접속자의 MBTI와 현재 상세 화면의 질문 대상이 되는 MBTI가 같은지 여부 (true | false)
   *  • author_mbti: 진입점이 된 질문의 질문자의 MBTI (e.g. ISFP)
   */
  askPostDetailViewed(params: AskPostDetailViewedParams): void {
    this.eventLogging(LogEvent.ASK_POST_DETAIL_VIEWED, {...params, exp_number: 'exp_002'});
  }
  
  
  /**
   * 로깅 붙임 여부(O)
   * [애스크 상세 화면]  상단에 ‘질문하기’를 누름
   * [Event Name]
   *  - Amplitude: Ask Post Detail - New Post Clicked
   *  - GA: click_ask_new_post
   * [Event Parameters]
   *  • screen_name: 화면 식별자 (ask_post_detail)
   *  • post_id: 진입점이 된 질문의 고유 식별자 (e.g. 123)
   *  • created_at: 진입점이 된 질문 등록 일시(UTC 기준) (e.g. 2022-01-11 15:33:20) 
   *  • like_count: 진입점이 된 질문의 라이크 개수 (e.g. 6)
   *  • comment_count: 진입점이 된 질문의 댓글 개수 (e.g. 8)
   *  • user_mbti: 접속자의 MBTI (e.g. ENFP)
   *  • list_mbti: 현재 화면의 항목들의 질문 대상이 되는 MBTI. 필터가 없으면 공란. (e.g. INTP)
   *  • is_list_mbti_mine: 접속자의 MBTI와 현재 화면의 항목들의 질문 대상이 되는 MBTI가 같은지 여부 (true | false)
   *  • author_mbti: 진입점이 된 질문의 질문자의 MBTI (e.g. ISFP)
   */
  askPostDetailNewPostClicked(params: AskPostDetailNewPostClickedParams): void {
    this.eventLogging(LogEvent.ASK_POST_DETAIL_NEW_POST_CLICKED, params);
  }
  
  
  /**
   * 로깅 붙임 여부(O)
   * [애스크 상세 화면] 질문의 ‘라이크’ 눌러서 지정함
   * [Event Name]
   *  - Amplitude: Ask Post Detail - Post Like Set Clicked
   *  - GA: click_post_like
   * [Event Parameters]
   *  • screen_name: 화면 식별자 (ask_post_detail)
   *  • post_id: 해당 질문의 고유 식별자 (e.g. 123)
   *  • is_entry_post: 진입점이 된 질문에서 발생했는지 여부 (true | false)
   *  • like_count: 누르기 전 질문의 라이크 개수 (e.g. 6)
   *  • comment_count: 질문의 댓글 개수 (e.g. 8)
   *  • user_mbti: 접속자의 MBTI (e.g. ENFP)
   *  • list_mbti: 현재 상세 화면의 질문 대상이 되는 MBTI. 필터가 없으면 공란. (e.g. INTP)
   *  • is_list_mbti_mine: 접속자의 MBTI와 현재 상세 화면의 질문 대상이 되는 MBTI가 같은지 여부 (true | false)
   *  • target_mbti: 현재 질문의 질문 대상이 되는 MBTI (e.g. INTP)
   *  • is_target_mbti_mine: 접속자의 MBTI와 현재 질문의 질문 대상이 되는 MBTI가 같은지 여부 (true | false)
   *  • author_mbti: 질문자의 MBTI (e.g. ISFP)
   */
  askPostDetailPostLikeSetClicked(params: AskPostDetailPostLikeClickedParams): void {
    this.eventLogging(LogEvent.ASK_POST_DETAIL_POST_LIKE_SET_CLICKED, params);
  }
  
  
  /**
   * 로깅 붙임 여부(O)
   * [애스크 상세 화면] 질문의 ‘라이크’ 눌러서 해제함
   * [Event Name]
   *  - Amplitude: Ask Post Detail - Post Like Unset Clicked
   *  - GA: click_post_like
   * [Event Parameters]
   *  • screen_name: 화면 식별자 (ask_post_detail)
   *  • post_id: 해당 질문의 고유 식별자 (e.g. 123)
   *  • is_entry_post: 진입점이 된 질문에서 발생했는지 여부 (true | false)
   *  • like_count: 누르기 전 질문의 라이크 개수 (e.g. 6)
   *  • comment_count: 질문의 댓글 개수 (e.g. 8)
   *  • user_mbti: 접속자의 MBTI (e.g. ENFP)
   *  • list_mbti: 현재 상세 화면의 질문 대상이 되는 MBTI. 필터가 없으면 공란. (e.g. INTP)
   *  • is_list_mbti_mine: 접속자의 MBTI와 현재 상세 화면의 질문 대상이 되는 MBTI가 같은지 여부 (true | false)
   *  • target_mbti: 현재 질문의 질문 대상이 되는 MBTI (e.g. INTP)
   *  • is_target_mbti_mine: 접속자의 MBTI와 현재 질문의 질문 대상이 되는 MBTI가 같은지 여부 (true | false)
   *  • author_mbti: 질문자의 MBTI (e.g. ISFP)
   */
  askPostDetailPostLikeUnsetClicked(params: AskPostDetailPostLikeClickedParams): void {
    this.eventLogging(LogEvent.ASK_POST_DETAIL_POST_LIKE_UNSET_CLICKED, params);
  }
  
  
  /**
   * 로깅 붙임 여부(O)
   * [애스크 상세 화면] 댓글의 ‘라이크’ 눌러서 지정함
   * [Event Name]
   *  - Amplitude: Ask Post Detail - Comment Like Set Clicked
   *  - GA: click_comment_like
   * [Event Parameters]
   *  • screen_name: 화면 식별자 (ask_post_detail)
   *  • post_id: 해당 질문의 고유 식별자 (e.g. 123)
   *  • comment_id: 해당 댓글의 고유 식별자 (e.g. 453)
   *  • is_entry_post: 진입점이 된 질문에서 발생했는지 여부 (true | false)
   *  • like_count: 누르기 전 댓글의 라이크 개수 (e.g. 6)
   *  • user_mbti: 접속자의 MBTI (e.g. ENFP)
   *  • author_mbti: 댓글 작성자의 MBTI (e.g. ISFP)
   */
  askPostDetailCommentLikeSetClicked(params: AskPostDetailCommentLikeClickedParams): void {
    this.eventLogging(LogEvent.ASK_POST_DETAIL_COMMENT_LIKE_SET_CLICKED, params);
  }
  
  
  /**
   * 로깅 붙임 여부(O)
   * [애스크 상세 화면] 댓글의 ‘라이크’ 눌러서 해제함
   * [Event Name]
   *  - Amplitude: Ask Post Detail - Comment Like Unset Clicked
   *  - GA: click_comment_like
   * [Event Parameters]
   *  • screen_name: 화면 식별자 (ask_post_detail)
   *  • post_id: 해당 질문의 고유 식별자 (e.g. 123)
   *  • comment_id: 해당 댓글의 고유 식별자 (e.g. 453)
   *  • is_entry_post: 진입점이 된 질문에서 발생했는지 여부 (true | false)
   *  • like_count: 누르기 전 댓글의 라이크 개수 (e.g. 6)
   *  • user_mbti: 접속자의 MBTI (e.g. ENFP)
   *  • author_mbti: 댓글 작성자의 MBTI (e.g. ISFP)
   */
  askPostDetailCommentLikeUnsetClicked(params: AskPostDetailCommentLikeClickedParams): void {
    this.eventLogging(LogEvent.ASK_POST_DETAIL_COMMENT_LIKE_UNSET_CLICKED, params);
  }
  
  
  /**
   * 로깅 붙임 여부(O)
   * [애스크 상세 화면] 질문 ‘신고’ 눌러서 질문 신고 팝업 띄움
   * [Event Name]
   *  - Amplitude: Ask Post Detail - Post Report Dialog Viewed
   *  - GA: show_dialog
   * [Event Parameters]
   *  • screen_name: 화면 식별자 (ask_post_detail)
   *  • post_id: 해당 질문의 고유 식별자 (e.g. 123)
   *  • is_entry_post: 진입점이 된 질문에서 발생했는지 여부 (true | false)
   */
  askPostDetailPostReportDialogViewed(params: AskPostDetailPostReportDialogViewedParams): void {
    this.eventLogging(LogEvent.ASK_POST_DETAIL_POST_REPORT_DIALOG_VIEWED, params);
  }
  
  
  /**
   * 로깅 붙임 여부(O)
   * [애스크 상세 화면] 질문 신고 팝업에서 ‘신고’ 누름
   * [Event Name]
   *  - Amplitude: Ask Post Detail - Post Report Clicked
   *  - GA: click_submit
   * [Event Parameters]
   *  • screen_name: 질문 신고 화면의 식별자 (ask_post_report)
   *  • post_id: 해당 질문의 고유 식별자 (e.g. 123)
   *  • is_entry_post: 진입점이 된 질문에서 발생했는지 여부 (true | false)
   */
  askPostDetailPostReportClicked(params: AskPostDetailPostReportClickedParams): void {
    this.eventLogging(LogEvent.ASK_POST_DETAIL_POST_REPORT_CLICKED, params);
  }
  
  
  /**
   * 로깅 붙임 여부(O)
   * [애스크 상세 화면] 댓글 ‘신고’ 눌러서 댓글 신고 팝업 띄움
   * [Event Name]
   *  - Amplitude: Ask Post Detail - Comment Report Dialog Viewed
   *  - GA: show_dialog
   * [Event Parameters]
   *  • screen_name: 화면 식별자 (ask_post_detail)
   *  • post_id: 해당 질문의 고유 식별자 (e.g. 123)
   *  • comment_id: 해당 댓글의 고유 식별자 (e.g. 453)
   *  • is_entry_post: 진입점이 된 질문에서 발생했는지 여부 (true | false)
   */
  askPostDetailCommentReportDialogViewed(params: AskPostDetailCommentReportDialogViewedParams): void {
    this.eventLogging(LogEvent.ASK_POST_DETAIL_COMMENT_REPORT_DIALOG_VIEWED, params);
  }
  
  
  /**
   * 로깅 붙임 여부(O)
   * [애스크 상세 화면] 댓글 신고 팝업에서 ‘신고’ 누름
   * [Event Name]
   *  - Amplitude: Ask Post Detail - Comment Report Clicked
   *  - GA: click_submit
   * [Event Parameters]
   *  • screen_name: 댓글 신고 화면의 식별자 (ask_reply_report)
   *  • post_id: 해당 질문의 고유 식별자 (e.g. 123)
   *  • comment_id: 해당 댓글의 고유 식별자 (e.g. 453)
   *  • is_entry_post: 진입점이 된 질문에서 발생했는지 여부 (true | false)
   */
  askPostDetailCommentReportClicked(params: AskPostDetailCommentReportClickedParams): void {
    this.eventLogging(LogEvent.ASK_POST_DETAIL_COMMENT_REPORT_CLICKED, params);
  }
  
  
  /**
   * 로깅 붙임 여부(O)
   * [애스크 상세 화면] 질문 ‘삭제’ 눌러서 질문 삭제 팝업 띄움
   * [Event Name]
   *  - Amplitude: Ask Post Detail - Post Delete Dialog Viewed
   *  - GA: show_dialog
   * [Event Parameters]
   *  • screen_name: 화면 식별자 (ask_post_detail)
   *  • post_id: 해당 질문의 고유 식별자 (e.g. 123)
   *  • is_entry_post: 진입점이 된 질문에서 발생했는지 여부 (true | false)
   */
  askPostDetailPostDeleteDialogViewed(params: AskPostDetailPostDeleteDialogViewedParams): void {
    this.eventLogging(LogEvent.ASK_POST_DETAIL_POST_DELETE_DIALOG_VIEWED, params);
  }
  
  
  /**
   * 로깅 붙임 여부(O)
   * [애스크 상세 화면] 질문 삭제 팝업에서 ‘삭제’ 누름
   * [Event Name]
   *  - Amplitude: Ask Post Detail - Post Delete Clicked
   *  - GA: click_confirm
   * [Event Parameters]
   *  • screen_name: 질문 삭제 화면의 식별자 (ask_post_delete)
   *  • post_id: 해당 질문의 고유 식별자 (e.g. 123)
   *  • is_entry_post: 진입점이 된 질문에서 발생했는지 여부 (true | false)
   */
  askPostDetailPostDeleteClicked(params: AskPostDetailPostDeleteClickedParams): void {
    this.eventLogging(LogEvent.ASK_POST_DETAIL_POST_DELETE_CLICKED, params);
  }
  
  
  /**
   * 로깅 붙임 여부(O)
   * [애스크 상세 화면] 댓글 ‘삭제’ 눌러서 댓글 삭제 팝업 띄움
   * [Event Name]
   *  - Amplitude: Ask Post Detail - Comment Delete Dialog Viewed
   *  - GA: show_dialog
   * [Event Parameters]
   *  • screen_name: 화면 식별자 (ask_post_detail)
   *  • post_id: 해당 질문의 고유 식별자 (e.g. 123)
   *  • comment_id: 해당 댓글의 고유 식별자 (e.g. 453)
   *  • is_entry_post: 진입점이 된 질문에서 발생했는지 여부 (true | false)
   */
  askPostDetailCommentDeleteDialogViewed(params: AskPostDetailCommentDeleteDialogViewedParams): void {
    this.eventLogging(LogEvent.ASK_POST_DETAIL_COMMENT_DELETE_DIALOG_VIEWED, params);
  }
  
  
  /**
   * 로깅 붙임 여부(O)
   * [애스크 상세 화면] 댓글 삭제 팝업에서 ‘삭제’ 누름
   * [Event Name]
   *  - Amplitude: Ask Post Detail - Comment Delete Clicked
   *  - GA: click_confirm
   * [Event Parameters]
   *  • screen_name: 댓글 삭제 화면의 식별자 (ask_reply_delete)
   *  • post_id: 해당 질문의 고유 식별자 (e.g. 123)
   *  • is_entry_post: 진입점이 된 질문에서 발생했는지 여부 (true | false)
   */
  askPostDetailCommentDeleteClicked(params: AskPostDetailCommentDeleteClickedParams): void {
    this.eventLogging(LogEvent.ASK_POST_DETAIL_COMMENT_DELETE_CLICKED, params);
  }
  
  /**
   * 로깅 붙임 여부(O)
   * [애스크 상세 화면] 댓글 입력 필드 옆 ‘게시’를 누름
   * [Event Name]
   *  - Amplitude: Ask Post Detail - Comment Submit Clicked
   *  - GA: click_submit
   * [Event Parameters]
   *  • screen_name: 화면 식별자 (ask_post_detail)
   *  • post_id: 해당 질문의 고유 식별자 (e.g. 123)
   *  • is_entry_post: 진입점이 된 질문에서 발생했는지 여부 (true | false)
   *  • like_count: 질문의 라이크 개수 (e.g. 6)
   *  • comment_count: 질문의 댓글 개수 (e.g. 8)
   *  • user_mbti: 접속자의 MBTI (e.g. ENFP)
   *  • list_mbti: 현재 상세 화면의 질문 대상이 되는 MBTI. 필터가 없으면 공란. (e.g. INTP)
   *  • is_list_mbti_mine: 접속자의 MBTI와 현재 상세 화면의 질문 대상이 되는 MBTI가 같은지 여부 (true | false)
   *  • target_mbti: 현재 질문의 질문 대상이 되는 MBTI (e.g. INTP)
   *  • is_target_mbti_mine: 접속자의 MBTI와 현재 질문의 질문 대상이 되는 MBTI가 같은지 여부 (true | false)
   *  • author_mbti: 질문자의 MBTI (e.g. ISFP)
   */
  askPostDetailCommentSubmitClicked(params: AskPostDetailCommentSubmitClickedParams): void {
    this.eventLogging(LogEvent.ASK_POST_DETAIL_COMMENT_SUBMIT_CLICKED, params);
  }
  
  
  /**
   * 로깅 붙임 여부(O)
   * [애스크 상세 화면] 뒤로 눌러서 이전화면으로 이동함
   * [Event Name]
   *  - Amplitude: Ask Post Detail - Navigation Back Performed
   *  - GA: navigation_back_performed
   * [Event Parameters]
   *  • screen_name: 화면 식별자 (ask_post_detail)
   *  • entry_post_id: 진입점이 된 질문의 고유 식별자 (e.g. 123)
   *  • [보류] performed_by: 어떻게 이전으로 이동했는지 (back key(안드로이드) | back button(왼쪽 위) | swipe(Left to Right 스와이프))
   *  • last_post_position: 스크롤을 내려서 최대로 도달했던 질문 항목의 position (e.g. 가장 아래에서 상단이 노출됐던 항목의 position. 진입점이 된 항목은 position이 0이고 찍히지 않으며, 두 번째 항목의 상단이 1픽셀이라도 노출됐으면 1)
   */
  askPostDetailNavigationBackPerformed(params: AskPostDetailNavigationBackPerformedParams): void {
    this.eventLogging(LogEvent.ASK_POST_DETAIL_NAVIGATION_BACK_PERFORMED, params);
  }
  
  
  /**
   * 로깅 붙임 여부(O)
   * [애스크 상세 화면] 스크롤 (Depth * Throttle * vh)
   * [Event Name]
   *  - Amplitude: Ask Post Detail - Scroll Ended
   *  - GA: scroll_ended
   * [Event Parameters]
   *  • screen_name: 화면 식별자 (ask_post_detail)
   *  • entry_post_id: 진입점이 된 질문의 고유 식별자 (e.g. 123)
   *  • user_mbti: 접속자의 MBTI (e.g. ENFP)
   *  • list_mbti: 현재 상세 화면의 질문 대상이 되는 MBTI. 필터가 없으면 공란. (e.g. INTP)
   *  • is_list_mbti_mine: 접속자의 MBTI와 현재 상세 화면의 질문 대상이 되는 MBTI가 같은지 여부 (true | false)
   *  • post_position: Scroll end 때 상단이 노출되기 시작한 질문 항목의 position (e.g. 화면 진입 시점에는 찍히지 않으며, scroll end일 때 다음 질문의 상단이 노출 안 되면 position이 0으로 찍힘. 두 번째 항목의 상단이 1픽셀이라도 노출된 채로 scroll end됐으면 1이 찍힘)
   */
  askPostDetailScrollEnded(params: AskPostDetailScrollEndedParams): void {
    this.eventLogging(LogEvent.ASK_POST_DETAIL_SCROLL_ENDED, params);
  }
  
  
  /**
   * 로깅 붙임 여부(O)
   * [글쓰기 Flow] 성격 유형 선택 BottomSheetDialog(Step 1)가 나타남
   * [Event Name]
   *  - Amplitude: Ask New Post - Mbti Select Viewed
   *  - GA: show_dialog
   * [Event Parameters]
   *  • screen_name: 화면 식별자 (home | ask_post_detail)
   *  • user_mbti: 접속자의 MBTI (e.g. ENFP)
   */
  askNewPostMbtiSelectViewed(params: AskNewPostMbtiSelectViewedParams): void {
    this.eventLogging(LogEvent.ASK_NEW_POST_MBTI_SELECT_VIEWED, params);
  }
  
  
  
  /**
   * 로깅 붙임 여부(O)
   * [글쓰기 Flow] 성격 유형 선택 BottomSheetDialog(Step 1)에서 Picker를 누름
   * [Event Name]
   *  - Amplitude: Ask New Post - Mbti Picker Opened
   *  - GA: open_option_list
   * [Event Parameters]
   *  • screen_name: 화면 식별자 (home | ask_post_detail)
   *  • user_mbti: 접속자의 MBTI (e.g. ENFP)
   */
  askNewPostMbtiPickerOpened(params: AskNewPostMbtiPickerOpenedParams): void {
    this.eventLogging(LogEvent.ASK_NEW_POST_MBTI_PICKER_OPENED, params);
  }
  
  
  /**
   * 로깅 붙임 여부(O)
   * [글쓰기 Flow] 성격 유형 선택 BottomSheetDialog(Step 1)에서 Picker를 눌러 나온 목록 중에 특정 MBTI 항목을 선택함
   * [Event Name]
   *  - Amplitude: Ask New Post - Mbti Selected
   *  - GA: select_option
   * [Event Parameters]
   *  • screen_name: 화면 식별자 (home | ask_post_detail)
   *  • user_mbti: 접속자의 MBTI (e.g. ENFP)
   *  • target_mbti: 선택한 MBTI (e.g. ENFJ)
   */
  askNewPostMbtiSelected(params: AskNewPostMbtiSelectedParams): void {
    this.eventLogging(LogEvent.ASK_NEW_POST_MBTI_SELECTED, params);
  }
  
  
  /**
   * 로깅 붙임 여부(O)
   * [글쓰기 Flow] 성격 유형 선택 단계에서 BottomSheetDialog가 닫힘
   * [Event Name]
   *  - Amplitude: Ask New Post - Mbti Select Dismissed
   *  - GA: dismiss_dialog
   * [Event Parameters]
   *  • screen_name: 화면 식별자 (home | ask_post_detail)
   *  • user_mbti: 접속자의 MBTI (e.g. ENFP)
   *  • [보류] performed_by: 어떻게 닫혔는지 (back key(안드로이드) | touch outside)
   *  • target_mbti: 선택한 MBTI (선택 안 한 채로 닫으면 공백. e.g. ENFJ)
   */
  askNewPostMbtiSelectDismissed(params: AskNewPostMbtiSelectDismissedParams): void {
    this.eventLogging(LogEvent.ASK_NEW_POST_MBTI_SELECT_DISMISSED, params);
  }
  
  
  /**
   * 로깅 붙임 여부(O)
   * [글쓰기 Flow] 물어보고 싶은 내용 작성 BottomSheetDialog(Step 2)가 나타남
   * [Event Name]
   *  - Amplitude: Ask New Post - Content Input Viewed
   *  - GA: show_dialog
   * [Event Parameters]
   *  • screen_name: 화면 식별자 (home | ask_post_detail)
   *  • user_mbti: 접속자의 MBTI (e.g. ENFP)
   *  • target_mbti: 선택한 MBTI (e.g. ENFJ)
   */
  askNewPostContentInputViewed(params: AskNewPostContentInputViewedParams): void {
    this.eventLogging(LogEvent.ASK_NEW_POST_CONTENT_INPUT_VIEWED, params);
  }
  
  /**
   * 로깅 붙임 여부(O)
   * [글쓰기 Flow] 물어보고 싶은 내용 작성 BottomSheetDialog(Step 2)에서 ‘작성 완료’를 누름
   * [Event Name]
   *  - Amplitude: Ask New Post - Post Submit Clicked
   *  - GA: click_submit
   * [Event Parameters]
   *  • screen_name: 화면 식별자 (home | ask_post_detail)
   *  • user_mbti: 접속자의 MBTI (e.g. ENFP)
   *  • target_mbti: 선택한 MBTI (e.g. ENFJ)
   *  • content_length: 작성한 내용의 길이 (e.g. 33)
   */
  askNewPostPostSubmitClicked(params: AskNewPostPostSubmitClickedParams): void {
    this.eventLogging(LogEvent.ASK_NEW_POST_POST_SUBMIT_CLICKED, params);
  }
  
  
  /**
   * 로깅 붙임 여부(O)
   * [글쓰기 Flow] 물어보고 싶은 내용 작성 단계에서 BottomSheetDialog가 닫힘
   * [Event Name]
   *  - Amplitude: Ask New Post - Content Input Dismissed
   *  - GA: dismiss_dialog
   * [Event Parameters]
   *  • screen_name: 화면 식별자 (home | ask_post_detail)
   *  • user_mbti: 접속자의 MBTI (e.g. ENFP)
   *  • [보류] performed_by: 어떻게 닫혔는지 (back key(안드로이드) | touch outside)
   *  • target_mbti: 선택한 MBTI (선택 안 한 채로 닫으면 공백. e.g. ENFJ)
   *  • content_length: 작성한 내용의 길이 (작성 안 한채로 닫으면 0. e.g. 33)
   */
  askNewPostContentInputDismissed(params: AskNewPostContentInputDismissedParams): void {
    this.eventLogging(LogEvent.ASK_NEW_POST_CONTENT_INPUT_DISMISSED, params);
  }

  private eventLogging(logEvent: LogEventKey, params: Record<string, string | boolean | number>): void {
    let newParams: Record<string, string | boolean | number> = {};
    Object.keys(params).forEach((key) => {
      newParams[snake_case(key)] = params[key];
    })
    this.logService.eventLogging(logEvent, newParams);
  }
}
